export default "__VITE_ASSET__0e17cd08__"